import { fixTooltipLabelFor, initializeComboboxes } from "./emphasis";
import { onDomReady } from "../assets/javascripts/utils";
import { initErrorSummary } from "./themes/emphasis/pages/event";
import "./themes/emphasis/interest-button";
import "./themes/emphasis/breadcrumb-toggle";

require("./common/tooltips");

// Require javascripts/themes/emphasis recursively
const themesEmphasis = require.context("javascripts/themes/emphasis", true);
themesEmphasis.keys().forEach(themesEmphasis);

onDomReady(() => {
  fixTooltipLabelFor();
  initializeComboboxes();

  // Initialize error summary on the public event submission form
  const page = document.querySelector('meta[name="localist-page"]');
  if (page && page.getAttribute("content") === "event-edit") {
    initErrorSummary();
  }
});
